import { makeStyles } from "@material-ui/core";
import _ from "lodash";
import { Button, useDataProvider } from "react-admin";
import { useFormState } from "react-final-form";

const useStyles = makeStyles({
  saveButton: {
    width: "100%",
    marginTop: 10,
    marginLeft: 0,
    borderRadius: 0,
    padding: 15,
    backgroundColor: "#E7E7E7",
    color: "#4E4E4E",
    fontWeight: 600,
    boxShadow: "unset",
    "&:hover": {
      backgroundColor: "#D8D8D8 !important",
    },
  },
});

const SaveManageStudentsButton = ({
  routeLocationData,
  handleClose,
  manageStudentCallback,
}: any) => {
  const classes = useStyles();
  const { values } = useFormState();
  const provider = useDataProvider();
  const newRouteLocation = _.clone(routeLocationData);

  const handleSaveManageStudent = () => {
    getStudentsByIds().then((students) => {
      newRouteLocation.students = students;

      manageStudentCallback(newRouteLocation);
    });
  };

  const getStudentsByIds = async () => {
    return await provider
      .getMany("students", { ids: values.studentIds })
      .then((result) => {
        return result.data;
      });
  };

  return (
    <Button
      label="Save"
      className={classes.saveButton}
      onClick={() => {
        handleSaveManageStudent();
        handleClose();
      }}
    />
  );
};

export default SaveManageStudentsButton;
